/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const NewRecordingIcon = /*#__PURE__*/ createSvgIcon(
  'NewRecordingIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.66 12.5v-5h1v5h-1z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.66 10.5h-5v-1h5v1z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M.5 4.5h11.242a2.13 2.13 0 012.078 2.176v6.648a2.128 2.128 0 01-2.078 2.176H2.565A2.13 2.13 0 01.5 13.324V4.5zm1 8.842A1.13 1.13 0 002.588 14.5h9.135a1.131 1.131 0 001.097-1.158V6.658A1.13 1.13 0 0011.723 5.5H1.5v7.842z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.5 5.562v8.876L12.893 10 19.5 5.562zM14.687 10l3.813 2.562V7.438L14.687 10z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default NewRecordingIcon;
